import React from 'react';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import {
  CategoryResultDTO,
  ComparedScoreDTO,
  ComparisonResultDTO,
  IndividualResultsDTO,
} from '../../../api/useSurveyResultsQuery';
import { CompatibilityHeader } from '../CompatibilityHeader/CompatibilityHeader';
import { IndividualHeader } from '../IndividualHeader/IndividualHeader';
import { SimilarityScore } from '../SimilarityScore/SimilarityScore';

interface Props {
  isComparing: boolean;
  individualResults: IndividualResultsDTO;
  comparisonResult: ComparisonResultDTO | null;
}

export const Hero = ({ isComparing, individualResults, comparisonResult }: Props) => {
  const { highlightedCategory } = individualResults;

  const featuredCategory = (isComparing && comparisonResult
    ? comparisonResult.comparedScores[highlightedCategory]
    : individualResults.categories[highlightedCategory]) as ComparedScoreDTO | CategoryResultDTO;

  return (
    <>
      <Text variant="smallCaps" color="neutral.600" textAlign="center">
        {isComparing && comparisonResult
          ? `Your Alignment with ${comparisonResult.partnerName}`
          : 'Your financial persona'}
      </Text>

      {isComparing && comparisonResult ? (
        <CompatibilityHeader
          compatibilityScore={comparisonResult.overallCompatibility}
          compatibilityStatus={comparisonResult.compatibilityStatus}
          primaryRespondentInitials={individualResults.initials}
          secondaryRespondentInitials={comparisonResult?.partnerInitials}
        />
      ) : (
        <IndividualHeader
          primaryRespondentScore={featuredCategory.score}
          primaryRespondentHeader={individualResults.header}
          primaryRespondentHighlightedCategory={highlightedCategory}
        />
      )}

      {isComparing && comparisonResult && (
        <SimilarityScore
          compatibilityScore={comparisonResult.overallCompatibility}
          secondaryRespondentName={comparisonResult.partnerName}
          mt="24"
        />
      )}

      <Text fontSize="h5" fontWeight={600} color="neutral.600" mt="24">
        {isComparing && comparisonResult
          ? comparisonResult.compatibilityDescription
          : featuredCategory.description}
      </Text>
    </>
  );
};
